// True only while react-snap is prerendering the site at build time (react-snap
// sets this user agent). Used to skip build-time-only side effects — e.g. an
// <img> onError fallback must NOT run during prerender, otherwise the blocked
// third-party image swaps in the placeholder and that placeholder gets baked
// into the static HTML instead of the real image URL.
export const isPrerender =
  typeof navigator !== 'undefined' && /ReactSnap/i.test(navigator.userAgent);

// Shared <img onError> fallback. No-op during prerender so the real src is kept.
export function imageFallback(fallbackSrc = '/default-offer.svg') {
  return (e) => {
    if (isPrerender) return;
    e.currentTarget.onerror = null;
    e.currentTarget.src = fallbackSrc;
  };
}
